export default __webpack_public_path__ + "static/media/materia_prima1.e7c5a929.jpg";